import { Container } from '@openedx/paragon';

const ExamplePage = () => (
  <main>
    <Container className="py-5">
      <h1>Example Page</h1>
      <p>Hello world!</p>
    </Container>
  </main>
);

export default ExamplePage;
